import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bbf3dccc"
import script from "./applyReceipt.js?vue&type=script&lang=js&external"
export * from "./applyReceipt.js?vue&type=script&lang=js&external"
import style0 from "./applyReceipt.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports